import { CompanyDocumentRecord } from "../../../../../models/DSF/CompanyDocuments";
import { Download, DownloadOff, Eye, EyeOff, ProgressActivity } from "../../../../../assets/icons";
import { downloadFile } from "../../../../../service/s3Service";
import React, { useRef, useState } from "react";
import { EquipmentRecord } from "../../../../../models/DSF/Equipment";
import { ChemicalRecord } from "../../../../../models/DSF/Chemicals";
import { VehicleRecord } from "../../../../../models/DSF/Vehicle";
import { Toast } from "primereact/toast";
import { useS3Service } from "../../../../../hooks/useS3Service";

function Documents({
  documents,
  loadingDocuments,
  errorDocuments,
  data,
}: {
  documents: CompanyDocumentRecord[];
  loadingDocuments: boolean;
  errorDocuments: boolean;
  data: EquipmentRecord | ChemicalRecord | VehicleRecord;
}) {
  const toast = useRef<any>(null);
  const [openingFile, setOpeningFile] = useState<string[]>([]);
  const [downloading, setDownloading] = useState<string[]>([]);
  const { openFileInNewTab } = useS3Service();
  return (
    <>
      {loadingDocuments ? (
        <div className={"loading-wrapper"}>
          <ProgressActivity className={"spinner"} />
        </div>
      ) : (
        <>
          {errorDocuments ? (
            <div className={"error-wrapper"}>
              <h2>Error fetching documents</h2>
            </div>
          ) : (
            <div className={"checklist-wrapper"}>
              {documents.length === 0 ? (
                <>
                  <p>No documents found for {data.name}</p>
                </>
              ) : (
                <>
                  <div className={"responsive-grid-2 checklist-table-header"}>
                    <p>Document name</p>
                    <p>Actions</p>
                  </div>
                  {documents.map((item, index) => {
                    return (
                      <div className={"responsive-grid-2"}>
                        <p>{item.name}</p>
                        <div className={"document-actions"}>
                          <div
                            className={item.s3_key && "cursor-pointer"}
                            onClick={async () => {
                              if (!item.s3_key) return;
                              const downloadingCopy = [...downloading];
                              downloadingCopy.push(item.s3_key);
                              setDownloading(downloadingCopy);
                              const down = await downloadFile(item.name, item.s3_key);
                              const downloadingCopy2 = [...downloading];
                              const index = downloadingCopy2.indexOf(item.s3_key);
                              downloadingCopy2.splice(index, 1);
                              setDownloading(downloadingCopy2);
                              if (down) {
                                toast.current.show({
                                  severity: "success",
                                  summary: "Downloaded",
                                  detail: `${item.name} downloaded successfully`,
                                });
                              } else {
                                toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: `Could not download ${item.name}`,
                                });
                              }
                            }}
                          >
                            {item.s3_key ? (
                              <Download className={"download-icon"} />
                            ) : (
                              <DownloadOff className={"nodownload-icon"} />
                            )}
                          </div>
                          <div
                            className={"cursor-pointer"}
                            onClick={async () => {
                              setOpeningFile([...openingFile, item.s3_key]);
                              await openFileInNewTab(item.name, item.s3_key);
                              const openingFileCopy = [...openingFile];
                              const index = openingFileCopy.indexOf(item.s3_key);
                              openingFileCopy.splice(index, 1);
                              setOpeningFile(openingFileCopy);
                            }}
                          >
                            {openingFile.includes(item.s3_key) ? (
                              <ProgressActivity className={"spinner"} />
                            ) : (
                              <>
                                {item.s3_key ? (
                                  <Eye className={"view-icon"} />
                                ) : (
                                  <EyeOff className={"nodownload-icon"} />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          )}
        </>
      )}
      <Toast ref={toast} />
    </>
  );
}

export default Documents;
